import SellingUnit from "@/components/SellingUnit";
import React from "react";
import { Link } from "react-router-dom";
import { X, Plus, Minus, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang, useL } from "@/i18n";
import { money } from "@/lib/api";

export default function CartDrawer() {
  const { items, open, setOpen, updateQty, removeItem, subtotal } = useCart();
  const { t } = useLang();
  const L = useL();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70]" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-navy/50 animate-fade-in" onClick={() => setOpen(false)} />
      <div className="absolute right-0 top-0 flex h-full w-full max-w-md flex-col bg-cream-card shadow-2xl">
        <div className="flex items-center justify-between border-b border-border p-5">
          <h3 className="flex items-center gap-2 font-display text-xl font-bold text-navy"><ShoppingBag size={20} /> {t("cart.title")}</h3>
          <button onClick={() => setOpen(false)} data-testid="cart-close-btn" aria-label="close"><X className="text-navy" /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-4 p-6 text-center">
            <ShoppingBag size={44} className="text-navy/20" />
            <p className="text-muted-foreground">{t("cart.empty")}</p>
            <button onClick={() => setOpen(false)} className="btn-gold rounded-full px-6 py-2.5 text-sm font-semibold">{t("common.shopNow")}</button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto p-4">
              {items.map((it) => (
                <div key={it.product_id} className="mb-3 flex gap-3 rounded-xl border border-border bg-cream p-3" data-testid={`cart-item-${it.slug}`}>
                  <img src={it.image} alt={L(it, "name")} className="h-20 w-20 shrink-0 rounded-lg object-cover" />
                  <div className="flex flex-1 flex-col">
                    <Link to={`/product/${it.slug}`} onClick={() => setOpen(false)} className="text-sm font-semibold text-navy line-clamp-2">{L(it, "name")}</Link><SellingUnit product={it} />
                    <span className="mt-1 text-sm font-bold text-navy">{money(it.price)}</span>
                    <div className="mt-auto flex items-center justify-between">
                      <div className="flex items-center gap-2 rounded-full border border-border bg-cream-card">
                        <button onClick={() => updateQty(it.product_id, it.quantity - 1)} className="grid h-7 w-7 place-items-center" aria-label="decrease"><Minus size={13} /></button>
                        <span className="w-5 text-center text-sm font-semibold">{it.quantity}</span>
                        <button onClick={() => updateQty(it.product_id, it.quantity + 1)} className="grid h-7 w-7 place-items-center" aria-label="increase"><Plus size={13} /></button>
                      </div>
                      <button onClick={() => removeItem(it.product_id)} className="text-muted-foreground transition hover:text-sunset" aria-label="remove"><Trash2 size={16} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-border p-5">
              <div className="mb-3 flex justify-between text-sm">
                <span className="text-muted-foreground">{t("common.subtotal")}</span>
                <span className="font-bold text-navy">{money(subtotal)}</span>
              </div>
              <Link to="/cart" onClick={() => setOpen(false)} className="mb-2 block rounded-full border border-navy py-3 text-center text-sm font-semibold text-navy transition hover:bg-cream" data-testid="view-cart-btn">{t("cart.title")}</Link>
              <Link to="/checkout" onClick={() => setOpen(false)} className="btn-gold block rounded-full py-3 text-center text-sm font-bold" data-testid="drawer-checkout-btn">{t("cart.checkout")}</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
